// extracted by mini-css-extract-plugin
export default {"hoverSubSystenName":"AddPlatform_hoverSubSystenName__wadxP","marginModel":"AddPlatform_marginModel__Xhpy6"};